import { Collapse } from 'react-bootstrap'
import { getIn } from 'formik'
import React from 'react'
import PropTypes from 'prop-types'

export default function ErrorMessage({ formik = {}, name, className = 'bg-white' }) {
  const { touched, errors } = formik
  return (
    <Collapse in={getIn(touched, name) && getIn(errors, name)}>
      <div>
        <div className={`card card-body p-0 border-0 ${className}`}>
          <div className="ws-errorbox">
            <p className="ws-errormessage">{getIn(errors, name)}</p>
          </div>
        </div>
      </div>
    </Collapse>
  )
}
ErrorMessage.propTypes = {
  formik: PropTypes.object,
  name: PropTypes.string,
  className: PropTypes.string,
}
